import { Injectable } from '@angular/core';
import { AppService } from '../@core/service/App.Service';
@Injectable({ providedIn: 'root' })
export class NotificationService extends AppService<any> {
  constructor() {
    super('Notification');
  }
  async getNotifications(userId: any) {
    const result = await this.get(`/${userId}`);
    return result?.Data;
  }
  async markAllAsRead(data) {
    return await this.put('',data);
  }
}
